export default __webpack_public_path__ + "static/ctaModule_cloud_bottom_mobile-b274958ed857877950585a1a0c68c096.png";